namespace Roodik.Game
{
	import ISoundManager = Roodik.Core.ISoundManager;

	export class AwardsModel
	{
		private _timeBonus:number = 0;
		private _chainBonus:number = 0;
		private _score:number = 0;
		private _chain:number = 0;
		private _addedScore:number = 0;
		private _maxChainCount:number = 1;

		constructor(private _soundManager:ISoundManager)
		{

		}

		public addScore()
		{
			if (this._chain == 5)
			{
				this._soundManager.playSound("money.mp3", 0.5);
				this._chainBonus += 250;
				this._addedScore = 250;
			}
			else if (this._chain == 10)
			{
				this._soundManager.playSound("money.mp3", 0.8);

				this._addedScore = 500;
				this._chainBonus += 500;
				this._maxChainCount++;
				this._chain = 0;
			}
			else
			{
				this._addedScore = 100;
				this._score += 100;
			}
		}

		public addBonus(timesLeft:number)
		{
			this._timeBonus = timesLeft*20;
		}

		public increaseChain()
		{
			this._chain ++;
		}

		public resetChain()
		{
			this._chain = 0;
		}

		public get chainBonus():number { return this._chainBonus; }
		public get timeBonus():number { return this._timeBonus; }
		public get addedScore():number { return this._addedScore; }
		public get score():number { return this._score + this._timeBonus + this._chainBonus; }
		public get chain():number { return this._chain; }
	}
}


// WEBPACK FOOTER //
// /source/src/typescript/Game/Model/AwardsModel.ts